import profileEditSubmitErrorAlertDictionary from '@widgets/profile-edit-submit-error-alert/i18n/ru/profile-edit-submit-error-alert.dic.json';

export const profileEditSubmitErrorAlert = {
  PROFILE_EDIT_SUBMIT_ERROR_ALERT: profileEditSubmitErrorAlertDictionary,
};

export const profileEditSubmitErrorAlertNamespaces = [
  'PROFILE_EDIT_SUBMIT_ERROR_ALERT',
];
